import { Action } from '@ngrx/store';
import { Job, TeamMembers } from '@shared/models';
import { Search } from '@shared/models/search';
import { Pagination } from '@shared/pagination';

export enum JobsActionTypes {
  Get = '[Jobs] Get',
  GetSuccess = '[Jobs] Get Success',
  GetFail = '[Jobs] Get Fail',

  Load = '[Jobs] Load',
  LoadGeneralRole = '[Jobs] Load for General Role',
  LoadHiringManager = '[Jobs] Load for Hiring Manager',
  LoadSuccess = '[Jobs] Load Success',
  LoadFail = '[Jobs] Load Fail',

  Select = '[Jobs] Select',
  Search = '[Jobs] Search',
  SelectSuccess = '[Jobs] Select Success',

  StatusUpdate = '[Jobs] Status Update',
  StatusUpdateSuccess = '[Jobs] Status Update Success',
  StatusUpdateFail = '[Jobs] Status Update Fail',
  Update = '[Jobs] Update',
  UpdateSuccess = '[Jobs] Update Success',
  UpdateFail = '[Jobs] Update Fail',

  Create = '[Jobs] Create',
  CreateSuccess = '[Jobs] Create Success',
  CreateFail = '[Jobs] Create Fail',

  TeamMembersLoad = '[Jobs] Get Team Members',
  TeamMembersUpdate = '[Jobs] Update Team Members',
  TeamMembersUpdateSuccess = '[Jobs] Update Team Members Success',
  TeamMembersUpdateFail = '[Jobs] Update Team Members Fail',

  LoadCompany = '[Jobs] Load Company',

  EmptyAction = '[Jobs] Empty Action',
}

export class JobsGet implements Action {
  readonly type = JobsActionTypes.Get;

  constructor(public payload?: any) {}
}

export class JobsGetSuccess implements Action {
  readonly type = JobsActionTypes.GetSuccess;

  constructor(public payload: Job) {}
}

export class JobsGetFail implements Action {
  readonly type = JobsActionTypes.GetFail;

  constructor(public payload?: any) {}
}

export class JobsLoad implements Action {
  readonly type = JobsActionTypes.Load;

  constructor(public payload?: any) {}
}

export class JobsLoadGeneralRole implements Action {
  readonly type = JobsActionTypes.LoadGeneralRole;

  constructor(public payload?: any) {}
}

export class JobsLoadHiringManager implements Action {
  readonly type = JobsActionTypes.LoadHiringManager;

  constructor(public payload?: any) {}
}

export class JobsLoadSuccess implements Action {
  readonly type = JobsActionTypes.LoadSuccess;

  constructor(public payload: Pagination<Job>) {}
}

export class JobsLoadFail implements Action {
  readonly type = JobsActionTypes.LoadFail;

  constructor(public payload?: any) {}
}

export class JobsSelect implements Action {
  readonly type = JobsActionTypes.Select;

  constructor(public id: number, public sort?: string) {}
}
export class JobsSelectSuccess implements Action {
  readonly type = JobsActionTypes.SelectSuccess;

  constructor(public payload: number = 0) {}
}

export class JobsUpdate implements Action {
  readonly type = JobsActionTypes.Update;

  constructor(public payload: Partial<Job>) {}
}

export class JobsLoadCompany implements Action {
  readonly type = JobsActionTypes.LoadCompany;

  constructor(public id: number) {}
}

export class JobsStatusUpdate implements Action {
  readonly type = JobsActionTypes.StatusUpdate;

  constructor(public payload: Partial<Job>) {}
}

export class JobsStatusUpdateSuccess implements Action {
  readonly type = JobsActionTypes.StatusUpdateSuccess;

  constructor(public payload: Job) {}
}

export class JobsStatusUpdateFail implements Action {
  readonly type = JobsActionTypes.StatusUpdateFail;

  constructor(public payload: any) {}
}

export class JobsUpdateSuccess implements Action {
  readonly type = JobsActionTypes.UpdateSuccess;

  constructor(public payload: Job) {}
}

export class JobsUpdateFail implements Action {
  readonly type = JobsActionTypes.UpdateFail;

  constructor(public payload: any) {}
}

export class JobsCreate implements Action {
  readonly type = JobsActionTypes.Create;

  constructor(public payload: Partial<Job>) {}
}

export class JobsCreateSuccess implements Action {
  readonly type = JobsActionTypes.CreateSuccess;

  constructor(public payload: Job) {}
}

export class JobsCreateFail implements Action {
  readonly type = JobsActionTypes.CreateFail;

  constructor(public payload: any) {}
}

// TEAM MEMBERS LIST
export class JobsTeamMembersLoad implements Action {
  readonly type = JobsActionTypes.TeamMembersLoad;

  constructor(public payload: Partial<Job>) {}
}

export class JobsTeamMembersUpdate implements Action {
  readonly type = JobsActionTypes.TeamMembersUpdate;
  constructor(public payload: { id: number; members: TeamMembers }) {}
}

export class JobsTeamMembersUpdateSuccess implements Action {
  readonly type = JobsActionTypes.TeamMembersUpdateSuccess;

  constructor(public payload: Job) {}
}

export class JobsTeamMembersUpdateFail implements Action {
  readonly type = JobsActionTypes.TeamMembersUpdateFail;

  constructor(public payload: any) {}
}

export class JobsSearch implements Action {
  readonly type = JobsActionTypes.Search;

  constructor(public payload: Search) {}
}

export class EmptyAction implements Action {
  readonly type = JobsActionTypes.EmptyAction;

  constructor() {}
}

export type JobsActionsUnion =
  | JobsGet
  | JobsGetSuccess
  | JobsGetFail
  | JobsLoad
  | JobsLoadGeneralRole
  | JobsLoadHiringManager
  | JobsLoadSuccess
  | JobsLoadFail
  | JobsSelect
  | JobsSelectSuccess
  | JobsUpdate
  | JobsLoadCompany
  | JobsSearch
  | JobsStatusUpdate
  | JobsStatusUpdateSuccess
  | JobsStatusUpdateFail
  | JobsUpdateSuccess
  | JobsUpdateFail
  | JobsCreate
  | JobsCreateSuccess
  | JobsCreateFail
  | JobsTeamMembersLoad
  | JobsTeamMembersUpdate
  | JobsTeamMembersUpdateSuccess
  | JobsTeamMembersUpdateFail
  | EmptyAction;
